import { Scene, SceneItem as SceneItemType } from '@monorepo/types';
import { FunctionComponent } from 'react';
import SceneItemComponent from './scene-item';

interface Props {
  items: SceneItemType[];
  scene: Scene;
}

const SceneItems: FunctionComponent<Props> = ({ items, scene }) => {
  return (
    <div className="scene-items">
      <div className="scene-items-list">
        {items.map((item) => (
          <SceneItemComponent scene={scene} item={item} key={item.index} />
        ))}
      </div>
    </div>
  );
};

export default SceneItems;
